<template>
    <div>
        <product-item
            v-for="product in products"
            :product="product"
            :key="product.id"
            :is-plus-size="isPlusSize"
        ></product-item>
    </div>
</template>

<script>

import ProductItem from './partials/ProductItem';

export default {
    name: 'ProductItemList',
    components: {
        ProductItem,
    },

    props: {
        products: {
            type: Array
        },

        isPlusSize: {
            type: Boolean,
            default: () => false,
        }
    }
}
</script>

<style scoped>

</style>
